import { Link, useHistory } from 'react-router-dom'

const ActionButton = (props) => {
  const history = useHistory()

  return <Link to={{ pathname: props.pathname, state: history.location.pathname }} style={{ ...props.style }} >
    <span>{props.name}</span>
  </Link>
}

export default ActionButton
